export const routesConfig = {
  "de-DE": {
    marketStep: "/de-de/product-guide",
    machineTonnageStep: "/de-de/product-guide/machine-tonnage",
    productStep: "/de-de/product-guide/product",
    otherOptionsStep: "/de-de/product-guide/optional",
    contactUsStep: "/de-de/product-guide/contact-us",
    thankYouStep: "/de-de/product-guide/thank-you",
  },
  "da-DK": {
    marketStep: "/da-dk/product-guide",
    machineTonnageStep: "/da-dk/product-guide/machine-tonnage",
    productStep: "/da-dk/product-guide/product",
    otherOptionsStep: "/da-dk/product-guide/optional",
    contactUsStep: "/da-dk/product-guide/contact-us",
    thankYouStep: "/de-dk/product-guide/thank-you",
  },
  en: {
    marketStep: "/en/product-guide",
    machineTonnageStep: "/en/product-guide/machine-tonnage",
    productStep: "/en/product-guide/product",
    otherOptionsStep: "/en/product-guide/optional",
    contactUsStep: "/en/product-guide/contact-us",
    thankYouStep: "/en/product-guide/thank-you",
  },
  "en-AU": {
    marketStep: "/en-au/product-guide",
    machineTonnageStep: "/en-au/product-guide/machine-tonnage",
    productStep: "/en-au/product-guide/product",
    otherOptionsStep: "/en-au/product-guide/optional",
    contactUsStep: "/en-au/product-guide/contact-us",
    thankYouStep: "/en-au/product-guide/thank-you",
  },
  "en-GB": {
    marketStep: "/en-gb/product-guide",
    machineTonnageStep: "/en-gb/product-guide/machine-tonnage",
    productStep: "/en-gb/product-guide/product",
    otherOptionsStep: "/en-gb/product-guide/optional",
    contactUsStep: "/en-gb/product-guide/contact-us",
    thankYouStep: "/en-gb/product-guide/thank-you",
  },
  "en-US": {
    marketStep: "/en-us/product-guide",
    machineTonnageStep: "/en-us/product-guide/machine-tonnage",
    productStep: "/en-us/product-guide/product",
    otherOptionsStep: "/en-us/product-guide/optional",
    contactUsStep: "/en-us/product-guide/contact-us",
    thankYouStep: "/en-us/product-guide/thank-you",
  },
  "es-ES": {
    marketStep: "/es-es/product-guide",
    machineTonnageStep: "/es-es/product-guide/machine-tonnage",
    productStep: "/es-es/product-guide/product",
    otherOptionsStep: "/es-es/product-guide/optional",
    contactUsStep: "/es-es/product-guide/contact-us",
    thankYouStep: "/en-es/product-guide/thank-you",
  },
  "fi-FI": {
    marketStep: "/fi-fi/tuoteopas",
    machineTonnageStep: "/fi-fi/tuoteopas/machine-tonnage",
    productStep: "/fi-fi/tuoteopas/product",
    otherOptionsStep: "/fi-fi/tuoteopas/optional",
    contactUsStep: "/fi-fi/tuoteopas/contact-us",
    thankYouStep: "/fi-fi/tuoteopas/thank-you",
  },
  "fr-FR": {
    marketStep: "/fr-fr/product-guide",
    machineTonnageStep: "/fr-fr/product-guide/machine-tonnage",
    productStep: "/fr-fr/product-guide/product",
    otherOptionsStep: "/fr-fr/product-guide/optional",
    contactUsStep: "/fr-fr/product-guide/contact-us",
    thankYouStep: "/fr-fr/product-guide/thank-you",
  },
  "fr-CA": {
    marketStep: "/fr-ca/product-guide",
    machineTonnageStep: "/fr-ca/product-guide/machine-tonnage",
    productStep: "/fr-ca/product-guide/product",
    otherOptionsStep: "/fr-ca/product-guide/optional",
    contactUsStep: "/fr-ca/product-guide/contact-us",
    thankYouStep: "/fr-ca/product-guide/thank-you",
  },
  "fr-BE": {
    marketStep: "/fr-be/product-guide",
    machineTonnageStep: "/fr-be/product-guide/machine-tonnage",
    productStep: "/fr-be/product-guide/product",
    otherOptionsStep: "/fr-be/product-guide/optional",
    contactUsStep: "/fr-be/product-guide/contact-us",
    thankYouStep: "/fr-be/product-guide/thank-you",
  },
  "ja-JP": {
    marketStep: "/ja-jp/product-guide",
    machineTonnageStep: "/ja-jp/product-guide/machine-tonnage",
    productStep: "/ja-jp/product-guide/product",
    otherOptionsStep: "/ja-jp/product-guide/optional",
    contactUsStep: "/ja-jp/product-guide/contact-us",
    thankYouStep: "/ja-jp/product-guide/thank-you",
  },
  "ko-KR": {
    marketStep: "/ko-kr/product-guide",
    machineTonnageStep: "/ko-kr/product-guide/machine-tonnage",
    productStep: "/ko-kr/product-guide/product",
    otherOptionsStep: "/ko-kr/product-guide/optional",
    contactUsStep: "/ko-kr/product-guide/contact-us",
    thankYouStep: "/ko-kr/product-guide/thank-you",
  },
  "nb-NO": {
    marketStep: "/nb-no/product-guide",
    machineTonnageStep: "/nb-no/product-guide/machine-tonnage",
    productStep: "/nb-no/product-guide/product",
    otherOptionsStep: "/nb-no/product-guide/optional",
    contactUsStep: "/nb-no/product-guide/contact-us",
    thankYouStep: "/nb-no/product-guide/thank-you",
  },
  "nl-NL": {
    marketStep: "/nl-nl/product-guide",
    machineTonnageStep: "/nl-nl/product-guide/machine-tonnage",
    productStep: "/nl-nl/product-guide/product",
    otherOptionsStep: "/nl-nl/product-guide/optional",
    contactUsStep: "/nl-nl/product-guide/contact-us",
    thankYouStep: "/nl-nl/product-guide/thank-you",
  },
  "nl-BE": {
    marketStep: "/nl-be/product-guide",
    machineTonnageStep: "/nl-be/product-guide/machine-tonnage",
    productStep: "/nl-be/product-guide/product",
    otherOptionsStep: "/nl-be/product-guide/optional",
    contactUsStep: "/nl-be/product-guide/contact-us",
    thankYouStep: "/nl-be/product-guide/thank-you",
  },
  "pl-PL": {
    marketStep: "/pl-pl/product-guide",
    machineTonnageStep: "/pl-pl/product-guide/machine-tonnage",
    productStep: "/pl-pl/product-guide/product",
    otherOptionsStep: "/pl-pl/product-guide/optional",
    contactUsStep: "/pl-pl/product-guide/contact-us",
    thankYouStep: "/pl-pl/product-guide/thank-you",
  },
  sv: {
    marketStep: "/sv/produktguiden/",
    machineTonnageStep: "/sv/produktguiden/maskin-vikt",
    productStep: "/sv/produktguiden/produkt",
    otherOptionsStep: "/sv/produktguiden/tillval",
    contactUsStep: "/sv/produktguiden/kontakta-oss",
    thankYouStep: "/sv/produktguiden/tack",
  },
  "sv-SE": {
    marketStep: "/sv/produktguiden/",
    machineTonnageStep: "/sv/produktguiden/maskin-vikt",
    productStep: "/sv/produktguiden/produkt",
    otherOptionsStep: "/sv/produktguiden/tillval",
    contactUsStep: "/sv/produktguiden/kontakta-oss",
    thankYouStep: "/sv/produktguiden/tack",
  },
};
